var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"home"},[_c('Hero',{attrs:{"slideTitle":"","slide":_vm.slide,"height":"90vh"}}),_c('Search'),_c('SelectiveProcess'),_c('Benefits'),_c('Inclusion'),_c('Testimonial')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }